/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  RDSDevicesStatusInput,
  RDSDevicesStatusType,
} from '..';
import {
  serializeRDSDevicesStatusInput,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface GetRDSDevicesStatusInput {
  input?: RDSDevicesStatusInput;
}
const build = (_query: DocumentNode, input: GetRDSDevicesStatusInput, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }(`+
    ( input.input !== undefined ? `$input: RDSDevicesStatusInput = ${serializeRDSDevicesStatusInput(input.input)}` : '' ) + `){
    getRDSDevicesStatus(
      ${ input.input !== undefined ? 'input: $input,' : '' }
    ){
      ...rdsdevicesstatustype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetRDSDevicesStatusQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment rdsdevicesstatustype on RDSDevicesStatusType { ... }
   */
  async execute(_query: DocumentNode, input: GetRDSDevicesStatusInput, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getRDSDevicesStatus: Partial<RDSDevicesStatusType> }>({ query: build(_query, input), fetchPolicy });
  }
}
